import React from 'react';
import { OverviewComponentType, ProductOverviewRegistry } from '../../types';
import ValueCreationScoreCard from '@containers/ValueCreationMetrics/RGMPricingAIValueCreation/ScoreCard';
import ApplicationPerformanceScorecard from '@containers/ApplicationPerformanceRedesigned/ApplicationPerformanceStandardMetrics/ApplicationPerformanceScorecard';
import SummaryMetrics from 'containers/GlobalUserAdoption/SummaryMetrics';

const scorecards: OverviewComponentType[] = [
  () => <ValueCreationScoreCard title={'Value Creation'} showInfoIcon={true} />,
  () => (
    <ApplicationPerformanceScorecard
      title={'App Performance'}
      showInfoIcon={true}
    />
  ),
  () => <SummaryMetrics title={'User Adoption'} />,
];

const customOverview: OverviewComponentType | null = null;

const pricingRegistry: ProductOverviewRegistry = {
  scorecards,
  customOverview,
};

export default pricingRegistry;
